import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import LoginPage from './components/LoginPage';
import { Dashboard } from './components/Dashboard';
import ElectronicMedicalRecord from './components/ElectronicMedicalRecord';
import { PatientProvider } from './components/PatientContext';
import RequireAuth from './components/RequireAuth';
import { AuthProvider } from './components/AuthProvider';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // Consider data fresh for 1 minute
      retry: 2, // Retry failed requests 2 times
      refetchOnWindowFocus: true, // Now we DO want to refetch on window focus
      refetchOnReconnect: true, // Refetch on reconnection
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />

            <Route
              path="/emr"
              element={
                <RequireAuth>
                  <PatientProvider>
                    <ElectronicMedicalRecord />
                  </PatientProvider>
                </RequireAuth>
              }
            />

            {/* Redirect root to login page */}
            <Route path="/" element={<Navigate to="/login" />} />
            
            {/* Catch all route - redirect to login */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;